import axiosInstance from '../../lib/api/axios';
import { getServerUrl } from '../../lib/utils';
import { SortableAccountColumns, SortOrders, Account, UpdateAccountPayload, GetAccountsResponse } from './types';

export const getUsers = async (
  page: number,
  perPage: number,
  query?: string,
  sortBy?: SortableAccountColumns,
  sortOrder?: SortOrders,
): Promise<GetAccountsResponse> => {
  const params = {
    page,
    perPage,
    query,
    ...(sortBy && {
      sortBy,
    }),
    ...(sortOrder && {
      sortOrder,
    }),
  };
  const { data } = await axiosInstance.get(
    `${getServerUrl()}/accounts`, { params },
  );
  return data;
};

export const updateAccount = async (
  id: number,
  payload: UpdateAccountPayload,
): Promise<Account> => {
  const { data } = await axiosInstance.patch(`${getServerUrl()}/accounts/${id}`, { ...payload });
  return data;
};

export const sendResetPasswordEmail = async (id: number): Promise<void> => {
  await axiosInstance.post(`${getServerUrl()}/accounts/${id}/actions/resetPassword`);
};

export const getAppConfig = async () : Promise<any> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/configuration`);
  return data;
};

export const exportAccounts = async (): Promise<string> => {
  const { data } = await axiosInstance.get(`${getServerUrl()}/accounts/actions/exportAccounts`);
  return data;
};